import React, { useMemo, useState } from 'react';
import Cake from '../../assets/images/No-Image.jpg';
import './itemCard.css';
import Modal from 'react-modal';
import CartModal from '../components/cartPopup';
import { connect } from 'react-redux';
import ComboPopup from './comboCart/comboPopup';
import { addAddon } from '../../../Redux/actions/addOnAction';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import GiftCardModal from './giftCardModal';

const IMAGE_URL = process.env.REACT_APP_IMAGE_URL;

const numberFmt = (code) =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: code || 'USD',
    minimumFractionDigits: 2,
  });

/** Resolve stock with sensible fallbacks.
 *  === 0  -> Out of stock (disable if you want)
 *  <  0   -> Unlimited (enabled)
 *  >  0   -> In stock
 */
const getStock = (v) => {
  const toInt = (x) => (x === undefined || x === null || x === '' || isNaN(parseInt(x)) ? null : parseInt(x));
  return (
    toInt(v?.stock) ??
    toInt(v?.stockQty) ??
    toInt(v?.availableQty) ??
    toInt(v?.quantityOnHand) ??
    toInt(v?.itemMasterVarients?.[0]?.stock) ??
    toInt(v?.itemMasterVarients?.[0]?.availableQty) ??
    0
  );
};

const getSalePrice = (v) => {
  const raw = v?.itemMasterVarients?.[0]?.salePrice ?? v?.salePrice ?? v?.price ?? 0;
  const n = parseFloat(raw);
  return isNaN(n) ? 0 : n;
};

const clampText = (text, max = 28) => {
  if (!text) return '';
  return text.length > max ? text.substring(0, max) + '…' : text;
};

/**
 * ✅ CRITICAL FIX:
 * Gift cards often don't have val.item or val.itemNo.
 * Some code inside CartModal / ComboPopup (or reducers) may read:
 *   CartValue.item.itemNo  OR  CartValue.itemNo
 * This guarantees BOTH exist + never null.
 */
const ensureItemShape = (val) => {
  const v = val ?? {};

  // choose best possible identifier
  const itemNo =
    v?.item?.itemNo ?? v?.itemNo ?? v?.barcode ?? v?.giftCardCode ?? v?.code ?? v?.cardNo ?? v?.cardNumber ?? v?.recordId ?? v?.id ?? `${Date.now()}`;

  const itemName = v?.item?.itemName ?? v?.itemName ?? v?.name ?? v?.title ?? v?.itemDescription ?? 'Item';

  const salePrice = Number(v?.item?.salePrice ?? v?.salePrice ?? v?.price ?? v?.amount ?? 0) || 0;

  const barcode = v?.item?.barcode ?? v?.barcode ?? v?.giftCardCode ?? v?.code ?? v?.cardNo ?? String(itemNo);

  const recordId = v?.item?.recordId ?? v?.recordId ?? v?.id ?? 0;

  return {
    ...v,
    // top-level fallbacks
    itemNo,
    itemName,
    salePrice,
    barcode,
    recordId,

    // nested item fallbacks (most important)
    item: {
      ...(v?.item ?? {}),
      itemNo,
      itemName,
      salePrice,
      barcode,
      recordId,
      taxRate: v?.item?.taxRate ?? 0,
      vat: v?.item?.vat ?? 0,
      isGiftCard: !!(v?.isGiftCard || v?.item?.isGiftCard),
    },
  };
};

const ItemCard = ({ val, addToCart, Currency, combo, addsOns, onAdd, giftCardMode }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [CartValue, setCartValue] = useState(null);
  const dispatch = useDispatch();

  // ✅ always normalized
  const [isGiftModalOpen, setIsGiftModalOpen] = useState(false);

  const safeVal = useMemo(() => ensureItemShape(val), [val]);
  const stock = getStock(safeVal);
  const outOfStock = stock === 0; // ✅ don't treat negative as OOS (negative = unlimited)
  const unlimited = stock < 0;

  const price = getSalePrice(safeVal);
  const money = numberFmt(Currency?.currency?.code);
  const isGiftCardItem = !!giftCardMode || !!safeVal?.isGiftCard || !!safeVal?.item?.isGiftCard || safeVal?.type === 'GIFT_CARD';
  const openModal = (item) => {
    const normalized = ensureItemShape(item);

    // Addons: direct add
    if (addsOns) {
      dispatch(addAddon(normalized));
      toast.success('Add-on added to cart');
      return;
    }

    // ✅ IMPORTANT: if parent provided onAdd, parent owns the behavior
    if (onAdd) {
      onAdd(normalized);
      return;
    }

    // ✅ Gift Card: internal flow ONLY when parent didn't override
    if (isGiftCardItem) {
      setCartValue(normalized);
      setIsGiftModalOpen(true);
      return;
    }

    // if (!normalized?.itemNo && !normalized?.item?.itemNo) {
    //   debugger;
    //   console.error('ItemCard: invalid item, missing itemNo', item);
    //   toast.error('Invalid item (missing item number).');
    //   return;
    // }

    setCartValue(normalized);
    setIsModalOpen(true);
  };

  const closeModal = () => setIsModalOpen(false);

  const closeGiftModal = () => setIsGiftModalOpen(false);

  const stockChip = (() => {
    if (outOfStock)
      return (
        <></>
        // <span
        //   className="badge"
        //   style={{
        //     backgroundColor: '#ffe3e3',
        //     color: '#c92a2a',
        //     border: '1px solid #ffa8a8',
        //     padding: '4px 8px',
        //     borderRadius: 999,
        //     fontSize: 12,
        //     fontWeight: 700,
        //   }}
        // >
        //   Out of stock
        // </span>
      );

    return (
      // <span
      //   className="badge"
      //   style={{
      //     backgroundColor: '#e6fcf5',
      //     color: '#087f5b',
      //     border: '1px solid #96f2d7',
      //     padding: '4px 8px',
      //     borderRadius: 999,
      //     fontSize: 12,
      //     fontWeight: 700,
      //   }}
      // >
      //   In stock
      // </span>
      <></>
    );
  })();

  const imgSrc = (safeVal?.imageUrl && `${IMAGE_URL || ''}${safeVal?.imageUrl}`) || (safeVal?.image && `${IMAGE_URL || ''}${safeVal?.image}`) || Cake;

  return (
    <div className="py-2">
      <div
        className="cashcard"
        style={{
          borderRadius: 14,
          border: '1px solid #edf1f5',
          boxShadow: '0 4px 14px rgba(16,24,40,0.06)',
          overflow: 'hidden',
          transition: 'transform .15s ease, box-shadow .15s ease',
        }}
        onMouseEnter={(e) => (e.currentTarget.style.boxShadow = '0 6px 18px rgba(16,24,40,0.10)')}
        onMouseLeave={(e) => (e.currentTarget.style.boxShadow = '0 4px 14px rgba(16,24,40,0.06)')}
      >
        {/* Media with stock chip */}
        <div style={{ position: 'relative' }}>
          <img
            className="itm_Img"
            src={imgSrc}
            alt={safeVal?.itemName || 'Item'}
            style={{ width: '100%', height: 160, objectFit: 'cover' }}
            onError={(e) => {
              e.currentTarget.onerror = null;
              e.currentTarget.src = Cake;
            }}
          />
          <div style={{ position: 'absolute', top: 10, left: 10 }}>{stockChip}</div>
        </div>

        {/* Content */}
        <div style={{ padding: 12 }}>
          <div className="card-Head" title={safeVal?.itemName} style={{ fontWeight: 700, fontSize: 15, color: '#0f172a' }}>
            {clampText(safeVal?.itemName, 32) || '--'}
          </div>

          {safeVal?.description ? (
            <div className="card-subHead" title={safeVal?.description} style={{ marginTop: 4, fontSize: 12.5, color: '#64748b' }}>
              {clampText(safeVal?.description, 40)}
            </div>
          ) : null}

          <div className="card-Prize" style={{ marginTop: 10, marginBottom: 12, fontWeight: 800, fontSize: 16, color: '#111827' }}>
            {money.format(price)}
          </div>

          <button
            className="AddCart-btn"
            onClick={() => openModal(safeVal)}
            // disabled={outOfStock} // enable if you want
            title="Add to cart"
            style={{
              width: '100%',
              padding: '10px 12px',
              borderRadius: 10,
              border: '1px solid',
              borderColor: '#6e5199',
              background: '#6e5199',
              color: '#fff',
              fontWeight: 700,
              fontSize: 14,
              cursor: 'pointer',
              transition: 'transform .05s ease, filter .15s ease',
            }}
            onMouseDown={(e) => {
              e.currentTarget.style.transform = 'translateY(1px)';
            }}
            onMouseUp={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
            }}
          >
            Add to cart
          </button>
        </div>

        <Modal isOpen={isModalOpen} onRequestClose={closeModal} ariaHideApp={false}>
          {!combo || combo?.length === 0 ? (
            <CartModal CartValue={CartValue} closeModal={closeModal} addToCart={addToCart} Currency={Currency} />
          ) : (
            <ComboPopup CartValue={CartValue} closeModal={closeModal} Currency={Currency} />
          )}
        </Modal>

        {/* ✅ Gift card modal */}
        <Modal isOpen={isGiftModalOpen} onRequestClose={closeGiftModal} ariaHideApp={false}>
          <GiftCardModal item={CartValue} closeModal={closeGiftModal} addToCart={addToCart} Currency={Currency} />
        </Modal>
      </div>
    </div>
  );
};

const mapStatetoProps = (state) => state;
export default connect(mapStatetoProps)(ItemCard);
